import { Log, User, UserManager } from 'oidc-client';

export class IipmOidcService {
  public userManager: UserManager;
  
  constructor() {
    const settings = {
      authority: `${process.env.REACT_APP_IDM_ENDPOINT}/realms/demo-page-pdmo`,
      client_id: "iipm",
      response_type: "code",
      scope: "openid profile email",
      automaticSilentRenew: false,
      monitorSession: false,
      loadUserInfo: true,
      redirect_uri: window.location.origin + '/iipm/signin-callback',
      post_logout_redirect_uri: window.location.origin + '/iipm', // ✅ IIPM logout ไป "/iipm"
    };

    this.userManager = new UserManager(settings);

    Log.logger = console;
    Log.level = Log.INFO;
  }

  public getUser(): Promise<User | null> {
    return this.userManager.getUser();
  }

  public login(): Promise<void> {
    window.localStorage.setItem("auth_system", "iipm");
    return this.userManager.signinRedirect();
  }

  public renewToken(): Promise<User> {
    return this.userManager.signinSilent();
  }

  public async logout(): Promise<void> {
    console.log("IipmOidcService.logout");
    localStorage.removeItem("access_token");
    localStorage.removeItem("auth_system");
    await this.userManager.removeUser();
    await this.userManager.clearStaleState();
    window.location.href = process.env.REACT_APP_IDM_ENDPOINT || "https://onepdmo.pdmo.go.th";
  }
  // public logout(): Promise<void> {
  //   console.log("IipmOidcService.logout - app only (no IdP logout)");
  //   console.log("process.env.REACT_APP_IDM_ENDPOINT:", `${process.env.REACT_APP_IDM_ENDPOINT}`);
  //   // Clear local tokens and auth flags for this app only
  //   window.localStorage.setItem("access_token", "");
  //   window.localStorage.removeItem("auth_system");
  //   // Remove the user from the local oidc-client store without redirecting to the identity provider
  //   return this.userManager.removeUser().then(() => {
  //     // Optionally navigate to the app root
  //     window.location.href = `${process.env.REACT_APP_IDM_ENDPOINT}`;
  //   });
  // }
}